import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { Disclaimer } from './pages/Disclaimer';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { RefundPolicy } from './pages/RefundPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/politica-de-privacidad" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/terminos-y-condiciones" element={<TermsAndConditions data-id="element-7" />} data-id="element-6" />
        <Route path="/politica-de-reembolsos" element={<RefundPolicy data-id="element-9" />} data-id="element-8" />
        <Route path="/descargo-de-responsabilidad" element={<Disclaimer data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}